import { DashboardRow } from 'generated/graphql';

interface getDashboardRowParams {
  rows: DashboardRow[];
  rowID: string;
}

export function getDashboardRow({ rowID, rows }: getDashboardRowParams) {
  return rows.find((row) => rowID === row.id);
}
